import { singletonHook } from 'react-singleton-hook';
import { useEffect, useState } from 'react';
import graphql from './graphqlClient'

const QUERY_USER = `{
    user {
        id
        idHashed
        email
        firstName
        lastName
        question
        role
        type
        subscription {
            id
            level
            expiresAt
            renew
        }
    }
}`

const init = { loading: true };

const locations = [
    'auth',
    'la-background-check',
    'xfile-newsletter',
    'signup',
    'appraiser'
]

function useCurrentUserImpl() {
    const [user, setUser] = useState(init)

    function loadUser() {
        graphql.request({
            query: QUERY_USER,
        })
        .then((response) => {
            const location = window.location.pathname.substring(1)
            let redirect = true

            if (response.data && !response.error) {
                setUser(response.data.user)

                return
            }

            locations.map((loc) => {
                if (location.match(loc)) {
                    redirect = false
                }
            })

            if (redirect) {
               window.location.href = '/auth/login?redirect=/' + location
            }

            setUser({ loading: false })
        })
    }

    useEffect(() => {
        loadUser()
    }, [])

    return user
}

const useCurrentUser = singletonHook(init, useCurrentUserImpl)

export default useCurrentUser

